import { connect } from 'react-redux'
import { IStoreState, ITripEdit } from '../../types'
import * as actions from '../../state/actions/provider-products/index'
import * as tripActions from '../../state/actions/trips'
import { CancelBillableModal } from '../../components/trips/CancelBillableModal'

export function mapStateToProps(state: IStoreState, ownProps: any): any {
  const currentTripId = ownProps.match.params.tripId
  const currentTrip = state.trips.items[currentTripId]
  const productId = currentTrip.product.productId ? currentTrip.product.productId : undefined
  const providerProduct = productId ? state.providerProduct.items[productId] : null
  return {
    currentTripId,
    currentTrip,
    providerProduct,
    loading: state.trips.isFetching,
    close: ownProps.history.goBack
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {
    fetchProduct: (productId: string) => {
      return dispatch(actions.fetchProduct(productId))
    },
    cancelBillable: async (
      tripId: string,
      paymentRequired: boolean,
      tripPrice?: number,
      comment?: string,
      disableNotification?: boolean
    ): Promise<any> => {
      return await dispatch(
        tripActions.cancelBillable(tripId, paymentRequired, tripPrice, comment, disableNotification)
      )
    },

    saveData: async (params: ITripEdit): Promise<any> => {
      return await dispatch(tripActions.saveData(params))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CancelBillableModal)



// WEBPACK FOOTER //
// ./src/containers/trips/CancelBillableModal.ts